export default __webpack_public_path__ + "static/media/Pramax-40-eng.537584e6.jpg";